import { applyMiddleware } from "redux";
import AuthorizedMiddleware from "./AuthorizedMiddleware";

const RootMiddleware = applyMiddleware(
  AuthorizedMiddleware
);

export default RootMiddleware;
